import { css } from '@emotion/css';

const styles = {
  container: css`
    display: flex;
    flex-direction: column;
    height: 99px;
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.25);
    z-index: 1;
  `,
  searchBoxContainer: css`
    display: flex;
    flex-direction: row;
    height: 65px;
  `,
  withSearchSpacing: css`
    padding: 16px 16px 16px 8px;
  `,
  withTitleSpacing: css`
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 23px;
  `,
  navBarTitleContainer: css`
    display: flex;
    flex: 1;
  `,
  backbuttonPosition: css`
    position: absolute;
    left: 16px;
  `,
  navBarTitle: css`
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
  `,
  newTitleIllustration: css`
    position: absolute;
    top: 10px;
    right: 0px;
  `,
};

export default styles;
